import "./Home.css";
import React, { useState } from "react";
import SideBar from "../../Components/Organisms/Bars/SideBar/SideBar";
import NavBar from "../../Components/Organisms/Bars/NavBar/NavBar";
import { Link, Route, Routes } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import useLogout from "../../Hooks/useLogout";
import { logoutURL } from "../../Hooks/URL";
import PrimaryButton from "../../Components/Atoms/Buttons/Primary/PrimaryButton";
import ProfilePage from "../../Pages/Profile/ProfilePage";
import PricingPage from "../../Pages/Pricing/PricingPage";
import AddTeamPage from "../../Pages/Teams/AddTeamPage";
import TeamsPage from "../../Pages/Teams/TeamsPage";
import MembersPage from "../../Pages/Members/MembersPage";
import AddMemberPage from "../../Pages/Members/AddMemberPage";
import CoachesPage from "../../Pages/Coaches/CoachesPage";
import AddCoachPage from "../../Pages/Coaches/AddCoachPage";
import TeamProfilePage from "../../Pages/Teams/TeamProfilePage";
import TransactionsPage from "../../Pages/Transactions/TransactionsPage";
import TransactionResultPage from "../../Pages/Transactions/TransactionResultPage";

function Home() {
  const [showMenu, setShowMenu] = useState(false);
  const [goSave, setGoSave] = useState(false);
  function handleShowMenu() {
    setShowMenu(!showMenu);
  }
  const { saveState } = useLogout({
    url: logoutURL,
    goSave,
    setGoSave,
  });

  return (
    <div className="Home">
      <NavBar showMenu={showMenu} setShowMenu={setShowMenu} />
      <div className="container">
        <div className={`sidebar ${showMenu ? "sidebarOpen" : "sidebarClose"}`}>
          <span
            className={"closeIcon mobile " + (showMenu ? "" : "hidden")}
            onClick={() => handleShowMenu()}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              padding: "0 20px",
            }}
          >
            <PrimaryButton
              classBtn={"center mobile"}
              text={"Logout"}
              click={() => {
                setGoSave(true);
                // setShowMenu(false);
              }}
              style={{
                textTransform: "capitalize",
                width: "100px",
                borderRadius: "5px",
                color: "#068399",
                backgroundColor: "white",
                height: "45px",
              }}
            />
            <CloseIcon
              sx={{
                fontSize: 30,
                marginBottom: 2,
                marginLeft: 2,
                cursor: "pointer",
              }}
            />
          </span>
          <SideBar setShowMenu={setShowMenu} />
        </div>
        <div className="main">
          <Routes>
            <Route path="/" element={<ProfilePage />} />
            <Route exact path="/transactions" element={<TransactionsPage />} />
            <Route exact path="/payment" element={<TransactionResultPage />} />
            <Route exact path="/pricing" element={<PricingPage />} />
            <Route exact path="/teams" element={<TeamsPage />} />
            <Route exact path="/teams/:id" element={<TeamProfilePage />} />
            <Route exact path="/teams/add" element={<AddTeamPage />} />
            <Route
              exact
              path="/teams/edit/:id/details"
              element={<AddTeamPage editType={"details"} />}
            />
            <Route
              exact
              path="/teams/edit/:id/member"
              element={<AddTeamPage editType={"members"} />}
            />
            <Route exact path="/members" element={<MembersPage />} />
            <Route exact path="/members/add" element={<AddMemberPage />} />
            <Route exact path="/members/edit/:id" element={<AddMemberPage />} />
            <Route exact path="/coaches" element={<CoachesPage />} />
            <Route exact path="/coaches/add" element={<AddCoachPage />} />
            <Route exact path="/coaches/edit/:id" element={<AddCoachPage />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Home;
